export const TRADE_EWA = {
  fairAbs: 0.15,
  riskyAbs: 0.35,
  winnerAbs: 0.05,
} as const;

export type TradeBalanceLabel = 'fair' | 'risky' | 'lopsided';
export type TradeWinner = 'your-team' | 'their-team' | 'balanced';

export interface ClassifiedTradeBalance {
  balance: TradeBalanceLabel;
  winner: TradeWinner;
  color: string;
}

export function classifyTradeBalance(ewa: number): ClassifiedTradeBalance {
  const abs = Math.abs(ewa);
  let balance: TradeBalanceLabel;
  let color: string;

  if (abs <= TRADE_EWA.fairAbs) {
    balance = 'fair';
    color = 'text-green-400';
  } else if (abs <= TRADE_EWA.riskyAbs) {
    balance = 'risky';
    color = 'text-yellow-400';
  } else {
    balance = 'lopsided';
    color = 'text-red-400';
  }

  const winner: TradeWinner =
    ewa > TRADE_EWA.winnerAbs
      ? 'your-team'
      : ewa < -TRADE_EWA.winnerAbs
        ? 'their-team'
        : 'balanced';

  return { balance, winner, color };
}
